import {
  Modal,
  message,
  Row,
  Col,
  Input,
  Spin,
  Button,
  Card,
  Space,
  Table,
  Popconfirm,
  Tag,
  Checkbox,
} from "antd";
import { useState } from "react";
import axios from "axios";
import {
  BASE_URL_BEN,
  HEADERS_EXPORT_BEN,
  POST_CANCEL_HAND_PRE,
  POST_CHECK_ADD_CANCEL_HAND,
} from "../../../API/apiUrls";
import {
  RestOutlined,
  SearchOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const AddCancel = ({ open, close, dataDefault, func }) => {
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [searchInput, setSearchInput] = useState(null);
  const [checkboxUnLogic, setCheckboxUnLogic] = useState(false);

  // แปลง item เดิม -> โครง record ใหม่ตามสเปก [0]
  const normalizeToNewShape = (item = {}) => ({
    DATA_TYPE: item.DATA_TYPE ?? item.dataType ?? null,
    CONTNO: item.CONTNO ?? item.contno ?? "",
    LPAYD: item.LPAYD ?? null,
    dateCancelContno: item.dateSend
      ? item.dateSend
      : item.dateCancelContno
      ? item.dateCancelContno
      : null,
    send: item.send ?? null,
    datePre: item.datePre ?? null,
  });

  const daysFrom = (d) =>
    d ? dayjs().startOf("day").diff(dayjs(d).startOf("day"), "day") : null;

  const daysFromLPAYD = (lpayd, dateCancel) =>
    lpayd
      ? dayjs(dateCancel)
          .startOf("day")
          .diff(dayjs(lpayd).startOf("day"), "day")
      : null;

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  const queryData = () => {
    const q = (searchInput || "").trim();
    const contnoSearch = dataDefault.filter(
      (item) => (item.contno ?? item.CONTNO) === q
    );
    const normalized = normalizeToNewShape(contnoSearch[0]);
    console.log(normalized);

    if (contnoSearch.length && checkboxUnLogic) {
      console.log("unLogic");

      setArrayTable((prev) => {
        const keyOf = (x) => x.CONTNO ?? x.contno;
        const map = new Map(prev.map((x) => [keyOf(x), x]));
        map.set(normalized.CONTNO, normalized);
        return Array.from(map.values());
      });
    }

    if (contnoSearch.length > 0) {
      if (!normalized.send) {
        return message.error(
          `อยู่ในรอบดำเนินการ ${dayjs(normalized.datePre)
            .add(543, "year")
            .format("D MMM YY")}`
        );
      }
      if (normalized.send && daysFrom(normalized.dateCancelContno) <= 45) {
        return message.error(
          `ออกบอกเลิกแล้วเมื่อ ${dayjs(normalized.dateCancelContno)
            .add(543, "year")
            .format("D MMM YY")}`
        );
      }
      setArrayTable((prev) => {
        const keyOf = (x) => x.CONTNO ?? x.contno;
        const map = new Map(prev.map((x) => [keyOf(x), x]));
        map.set(normalized.CONTNO, normalized);
        return Array.from(map.values());
      });
    } else {
      loadData(q);
    }
  };

  const loadData = async (contno) => {
    setLoading(true);
    console.log("contno", contno);

    try {
      await axios
        .post(
          POST_CHECK_ADD_CANCEL_HAND,
          { CONTNO: `${contno}` },
          {
            headers: HEADERS_EXPORT_BEN,
          }
        )
        .then(async (res) => {
          if (res.status === 200) {
            if (res.data.success === "ปิดไปแล้ว") {
              message.warning("ปิดไปแล้ว");
            } else if (res.data.success === "ไม่พบสัญญา") {
              message.warning("ไม่พบสัญญา");
            } else {
              const normalized = normalizeToNewShape(res.data);
              console.log(normalized);
              const dateForAdd = daysFromLPAYD(
                normalized.LPAYD,
                normalized.dateCancelContno || dayjs()
              );
              console.log("d", dateForAdd);
              if (dateForAdd >= 45 || checkboxUnLogic) {
                setArrayTable((prev) => {
                  const keyOf = (x) => x.CONTNO ?? x.contno;
                  const map = new Map(prev.map((x) => [keyOf(x), x]));
                  map.set(normalized.CONTNO, normalized);
                  return Array.from(map.values());
                });
              } else {
                const parts = [];

                if (normalized?.LPAYD) {
                  parts.push(
                    `จ่ายล่าสุดเมื่อ ${dayjs(normalized.LPAYD)
                      .add(543, "year")
                      .format("D MMM YY")}`
                  );
                }
                if (normalized?.dateCancelContno) {
                  parts.push(
                    `ออกบอกเลิกเมื่อ ${dayjs(normalized.dateCancelContno)
                      .add(543, "year")
                      .format("D MMM YY")}`
                  );
                }

                return message.error(parts.join("  "));
              }
            }
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err);
          message.error("ไม่พบข้อมูลสัญญา");
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const onChangeInputSearch = (data) => {
    setSearchInput(data);
  };

  const confirmDelete = (record) => {
    if (!record) {
      message.error("ไม่พบรายการที่จะลบ");
      return;
    }
    const contno = record.CONTNO ?? record.contno;
    if (!contno) {
      message.error("ไม่มีเลขที่สัญญาในรายการนี้");
      return;
    }

    // ลบทุกแถวที่มี CONTNO/contno ตรงกัน (กันเคสซ้ำ)
    setArrayTable((prev) =>
      prev.filter((row) => (row.CONTNO ?? row.contno) !== contno)
    );

    message.success(`ลบสัญญาเรียบร้อย: ${contno}`);
  };

  const cancelDelete = (e) => {
    console.log(e);
    message.error("ยกเลิกการลบสัญญา");
  };

  const handleOk = () => {
    const payload = arrayTable
      .map((r) => ({
        CONTNO: String(r?.CONTNO ?? "").trim(),
        DATA_TYPE: String(r?.DATA_TYPE ?? r?.dataType ?? "").trim(), // รองรับ dataType/ DATA_TYPE
      }))
      .filter((r) => r.CONTNO && r.DATA_TYPE);

    console.log(payload);
    if (payload.length > 0) {
      insertData(payload);
    } else {
      message.warning("ไม่มีข้อมูล");
    }
  };

  const onChangeCheckbox = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setCheckboxUnLogic(e.target.checked);
  };

  const insertData = async (payload) => {
    setLoading(true);

    try {
      const res = await axios.post(
        BASE_URL_BEN + POST_CANCEL_HAND_PRE,
        payload,
        {
          headers: HEADERS_EXPORT_BEN,
        }
      );
      if (res.status === 200) {
        message.success("บันทึกข้อมูลสำเร็จ");
      } else {
        message.error("บันทึกข้อมูลไม่สำเร็จ");
      }
    } catch (err) {
      const status = err?.response?.status;
      console.error("queryMultiData error:", err);

      message.error(
        `เกิดข้อผิดพลาดในการดึงข้อมูล${status ? ` (${status})` : ""}`
      );
    } finally {
      func(true);
      setLoading(false);
      handleCancel();
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "contract_no",
      key: "contract_no",
      align: "center",
      render: (text, record) => <>{record.CONTNO ? record.CONTNO : null}</>,
    },
    {
      title: "สถานะ",
      align: "center",
      render: (text, record) => (
        <Tag
          color={
            record.dateCancelContno ? "red" : record.datePre ? "purple" : "blue"
          }
        >
          {record.dateCancelContno
            ? "ออกจดหมายแล้ว"
            : record.datePre
            ? "รอดำเนินการ"
            : "ยังไม่ออกจดหมาย"}
          <br />
          {record.dateCancelContno
            ? dayjs(record.dateCancelContno).add(543, "year").format("D MMM YY")
            : record.datePre
            ? dayjs(record.datePre).add(543, "year").format("D MMM YY")
            : null}
        </Tag>
      ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (text, record) => (
        <>
          <Popconfirm
            title="ลบสัญญา"
            description="คุณต้องการลบสัญญานี้ใช่หรือไม่ ?"
            onConfirm={() => {
              confirmDelete(record);
            }}
            onCancel={cancelDelete}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <Button style={{ fontSize: "16px", color: "red" }}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        <span style={{ fontSize: 16, fontWeight: 400, color: "#333" }}>
          เลือกสัญญาออกบอกเลิก
        </span>
      }
      open={open}
      onCancel={handleCancel}
      width={"auto"}
      keyboard={true}
      maskClosable={false}
      centered
      footer={[
        <Button
          danger
          key="cancel"
          onClick={handleCancel}
          style={{ color: "red" }}
        >
          ปิด
        </Button>,
        <Button color="blue" variant="outlined" key="ok" onClick={handleOk}>
          บันทึก
        </Button>,
      ]}
    >
      <Spin spinning={loading} size="large" tip=" Loading... ">
        <Row>
          <Col span={"24"} style={{ textAlign: "center", marginBottom: 20 }}>
            <Space size={8} direction="herizental" style={{ marginRight: 10 }}>
              <Checkbox onChange={onChangeCheckbox}>
                นำเข้าไม่มีเงื่อนไข
              </Checkbox>
              <Input
                placeholder="ค้นหาสัญญา"
                onChange={(e) => onChangeInputSearch(e.target.value)}
                style={{ width: "100%", borderRadius: 8, marginBottom: 5 }}
                size="small"
                suffix={<span style={{ marginRight: 5 }}>👤</span>}
              />
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                }}
                onClick={queryData}
                disabled={loading}
              >
                ค้นหา
              </Button>
              <Button
                icon={<RestOutlined />}
                size="large"
                onClick={() => setArrayTable([])}
                type="default"
                danger
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.06)",
                  fontWeight: "bold",
                }}
                disabled={loading}
              >
                ล้างข้อมูลตาราง
              </Button>
            </Space>
          </Col>
        </Row>
        <Card>
          <Table
            style={{ marginTop: "10px" }}
            size="small"
            columns={columns}
            dataSource={arrayTable}
            scroll={{ x: 850 }}
            footer={() => <p>จำนวนสัญญาที่ค้นหาทั้งหมด {arrayTable.length}</p>}
          />
        </Card>
      </Spin>
    </Modal>
  );
};
export default AddCancel;
